import { useEffect } from 'react'

/**
 * Bootstraps a preview session from a short-lived preview token.
 * The admin opens this page in a new tab with #token=xxx&client=Name. The token travels in the URL
 * fragment (not the query string) so it is never sent to a server, logged, or captured as a request URL.
 *
 * We store the token in sessionStorage then do a HARD redirect to /portal/team.
 * A hard redirect is required so that AuthContext reinitialises from sessionStorage
 * on the fresh page load — a React navigate() won't work because AuthContext
 * already read sessionStorage (and found nothing) when this tab first loaded.
 */
export default function PreviewEntryPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
    const token = params.get('token')
    const clientName = params.get('client')

    if (!token) {
      window.location.replace('/login')
      return
    }

    sessionStorage.setItem('accessToken', token)
    sessionStorage.setItem('previewClientName', clientName ?? 'Client')

    // Hard redirect — forces AuthContext to reinitialise from sessionStorage
    window.location.replace('/portal/overview')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <p className="text-gray-500 text-sm">Loading preview…</p>
    </div>
  )
}
